/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Profile_Split_Auto_ValueInputs */

const en_us2_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatic · ${i?.name}`)
};

const pt_br2_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automático · ${i?.name}`)
};

const es_419_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automática · ${i?.name}`)
};

const pt_pt2_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automática · ${i?.name}`)
};

const fr_fr2_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatique · ${i?.name}`)
};

const de_de2_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatisch · ${i?.name}`)
};

const it_it2_profile_split_auto_value = /** @type {(inputs: Profile_Split_Auto_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Automatica · ${i?.name}`)
};

/**
* | output |
* | --- |
* | "Automatic · {name}" |
*
* @param {Profile_Split_Auto_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_split_auto_value = /** @type {((inputs: Profile_Split_Auto_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Split_Auto_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_split_auto_value(inputs)
	if (locale === "es-419") return es_419_profile_split_auto_value(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_split_auto_value(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_split_auto_value(inputs)
	if (locale === "de-DE") return de_de2_profile_split_auto_value(inputs)
	if (locale === "it-IT") return it_it2_profile_split_auto_value(inputs)
	return en_us2_profile_split_auto_value(inputs)
});
export { profile_split_auto_value as "profile.split_auto_value" }